export const FORM_VERSION_METADATA_KEY = '$$__formVersion'
export const PREVIEW_PATH_PREFIX = '/preview'
export const FORM_PREFIX = ''
export const EXTERNAL_STATE_PAYLOAD = 'EXTERNAL_STATE_PAYLOAD'
export const EXTERNAL_STATE_APPENDAGE = 'EXTERNAL_STATE_APPENDAGE'
export const COMPONENT_STATE_ERROR = 'COMPONENT_STATE_ERROR'
export const PAYMENT_EXPIRED_NOTIFICATION = 'PAYMENT_EXPIRED_NOTIFICATION'
